// Реактивный источник safe-area инсетов для web-стилей. По умолчанию нули (обычный браузер),
// но в Telegram Mini App fullscreen сюда прокидывается верхний инсет (см. web use-tma-fullscreen),
// и все стили, читающие `safe` из createStyleSheet, перерисовываются через useSyncExternalStore.
export type WebSafeArea = { top: number; right: number; bottom: number; left: number }

const ZERO: WebSafeArea = { top: 0, right: 0, bottom: 0, left: 0 }

let current: WebSafeArea = ZERO
const listeners = new Set<() => void>()

function isEqual(a: WebSafeArea, b: WebSafeArea): boolean {
  return a.top === b.top && a.right === b.right && a.bottom === b.bottom && a.left === b.left
}

export function getWebSafeArea(): WebSafeArea {
  return current
}

export function setWebSafeArea(next: Partial<WebSafeArea>): void {
  const merged: WebSafeArea = { ...current, ...next }

  if (isEqual(merged, current)) return

  current = merged

  for (const listener of listeners) listener()
}

export function subscribeWebSafeArea(listener: () => void): () => void {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
